/**
 * 위치정보 접속기록 (/adm/location/access-log) — 관리자 위치정보 화면 접속 기록
 * ($j.Pages.Admin.AdminLoginLog / body data-page-name="AdminLoginLog")
 */
export default class AdminLoginLog {
    initialize() {
        let $table = null;

        $(function () {
            loadTable();
        });

        function loadTable() {
            const columns = [
                {data: 'rownum', title: '번호', width: '60px'},
                {data: 'mb_id', title: '아이디', width: '120px'},
                {data: 'level_str', title: '권한', width: '150px'},
                {data: 'name', title: '이름', width: '100px'},
                {
                    data: null, title: '구분', width: '120px',
                    render: function () { return '위치정보조회'; }
                },
                {data: 'res', title: '로그인여부', width: '100px'},
                {data: 'ip', title: '아이피', width: '140px'},
                {data: 'datetime', title: '날짜', width: '160px', render: v => $j.Common.Util.formatDateTime(v)}
            ];

            if ($table) {
                $table.destroy();
                $('#log-table').empty();
            }

            $table = new DataTable('#log-table', {
                autoWidth: false,
                columns: columns,
                headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
                ajax: {
                    url: '/adm/ajax/location/access-log/list',
                    type: 'post'
                },
                language: {
                    emptyTable: "데이터가 없습니다.",
                    info: "",
                    infoEmpty: "",
                    infoFiltered: "",
                    loadingRecords: "로딩 중...",
                    zeroRecords: "일치하는 결과가 없습니다.",
                    paginate: {
                        previous: "<i class='fa fa-chevron-left'></i>",
                        next: "<i class='fa fa-chevron-right'></i>"
                    }
                },
                processing: true,
                serverSide: true,
                ordering: false,
                pageLength: 25,
                lengthChange: false,
                searching: false
            });
        }

    }
}
